import React, { useState } from "react";
import ReactDom from "react-dom";
import { Pagination, Button, Space, Skeleton, Table, Modal, message, Tooltip, Spin, ConfigProvider } from "antd";
import zhCN from "antd/lib/locale/zh_CN";
import SearchConditionList from "./search-condition-list";
import { lib, event } from "@/index";
import SortTable from "./sort-table";
import "./index.less";
import { Resizable } from "react-resizable";
import MyDraggable from "./draggable";
import Immutable from "immutable";
import { QuestionCircleOutlined } from "@ant-design/icons";
import md5 from "md5";
import { ExportBtn } from "../../component/export-btn";
import { SearchSourceType } from "./search-constant";

const ResizableTitle = props => {
    const { onResize, ...restProps } = props;
    let [width, setWidth] = useState(props.width);
    let [resizing, setResizing] = useState(false);
    if (!width) {
        return <th {...restProps} />;
    }
    let thStyle = { ...restProps.style },
        handleStyle = {};
    if (resizing) {
        handleStyle = { left: `${width - 11}px` };
        thStyle.zIndex = 10;
    }
    return (
        <Resizable
            width={width}
            height={0}
            handle={
                <div
                    className={`resizable-handle ${resizing && "resizing"}`}
                    onClick={e => {
                        e.stopPropagation();
                    }}
                    style={handleStyle}></div>
            }
            onResizeStart={() => setResizing(true)}
            onResize={(e, { size }) => {
                if (size.width > 80 && size.width < 800) {
                    setWidth(size.width);
                }
            }}
            onResizeStop={(e, p) => {
                setResizing(false);
                onResize(e, p);
            }}
            draggableOpts={{ enableUserSelectHack: false }}>
            <th {...restProps} style={thStyle}>
                <div className="title">{restProps.children}</div>
            </th>
        </Resizable>
    );
};

export default class SearchList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                currentPage: 1,
                pageSize: 20,
                totalPage: 1,
            },
            search: {},
            dataList: [],
            config: null,
            table: {
                panel: React.createRef(),
                height: 500,
            },
            selectedRows: [],
            selectedIdList: [],
            sorter: {},
            defaultSearch: Immutable.Map({}),
            buttons: [],
            expandedRowKeys: [], // 添加展开行的状态管理
        };
        this.searchRef = React.createRef();
        this.loadConfig();
        this.resetSize = this.resetSize.bind(this);
        window.addEventListener("resize", this.resetSize, false);
        event.on("window.resize", this.resetSize);
        setTimeout(this.resetSize, 100);
        this.load = this.load.bind(this);
    }
    loadConfig() {
        Promise.resolve(this.getConfig())
            .then(config => {
                config.tableFieldListVersion = md5(JSON.stringify(config.tableFieldList));
                let storage = localStorage[config.id];
                if (storage) {
                    storage = JSON.parse(storage);
                    if (storage.tableFieldListVersion == config.tableFieldListVersion) {
                        config.tableFieldList = storage.tableFieldList;
                    } else {
                        // 待优化部分，页面字段变动引起的tableFieldListVersion缓存不一致情况
                    }
                }
                return config;
            })
            .then(
                config =>
                    config &&
                    this.setState({ config }, () => {
                        this.setConfigSuccess && this.setConfigSuccess();
                    }),
            )
            .catch(e => this.setState({ config: "出错了" }));
    }
    resetSize() {
        this.resetSize.timer && clearTimeout(this.resetSize.timer);
        this.resetSize.timer = setTimeout(() => {
            let { table } = this.state;
            if (table.panel.current?.offsetHeight) {
                table.height = table.panel.current.offsetHeight - 40;
                this.setState({ table });
            }
        }, 100);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.resetSize);
        event.off("window.resize", this.resetSize);
    }
    load(_, toTop) {
        let { pagination, search, config, sorter } = this.state;
        var data = {},
            configDefaultParams = this.configLoadDefaultParams();
        this.setState({ _loading: true });
        Object.assign(data, pagination, search, sorter);
        lib.request({
            url: config.page.api,
            data: Object.assign(data, configDefaultParams),
            success: data => {
                // 处理树形数据，移除空的 children 数组
                const processTreeData = list => {
                    if (!Array.isArray(list)) return list;
                    return list.map(item => {
                        const newItem = { ...item };
                        if (Array.isArray(newItem.children)) {
                            if (newItem.children.length === 0) {
                                // 如果 children 是空数组，删除该字段以避免显示展开按钮
                                delete newItem.children;
                            } else {
                                // 如果有子节点，递归处理
                                newItem.children = processTreeData(newItem.children);
                            }
                        }
                        return newItem;
                    });
                };

                const processedDataList = config.page.onlyOneLevel
                    ? processTreeData(data)
                    : processTreeData(data.dataList || []);

                this.setState({
                    pagination: data.page,
                    dataList: processedDataList,
                    _loading: false,
                });

                toTop && (document.querySelector(".table-panel .ant-table-body").scrollTop = 0);
                setTimeout(this.resetSize, 100);
                // 添加 afterLoad 钩子，用于自定义控制展开行
                this.afterLoad && this.afterLoad(data || []);
            },
            fail: e => {
                this.setState({
                    _loading: false,
                });
            },
        });
    }
    /**
     *  load请求默认参数
     * @returns {{}}
     */
    configLoadDefaultParams() {
        return {};
    }

    /**
     * 处理表格行展开/收起事件
     * @param {boolean} expanded - 是否展开
     * @param {object} record - 当前行数据
     */
    handleExpand = (expanded, record) => {
        const { expandedRowKeys } = this.state;
        const rowKey = record.id; // 使用 id 作为 rowKey

        let newExpandedRowKeys;
        if (expanded) {
            // 展开：添加到展开列表
            newExpandedRowKeys = [...expandedRowKeys, rowKey];
        } else {
            // 收起：从展开列表中移除
            newExpandedRowKeys = expandedRowKeys.filter(key => key !== rowKey);
        }

        this.setState({ expandedRowKeys: newExpandedRowKeys });

        // 如果有自定义的展开回调，则调用
        this.onExpand && this.onExpand(expanded, record, newExpandedRowKeys);
    };

    /**
     * 设置展开的行键列表（供外部调用）
     * @param {array} expandedRowKeys - 要展开的行键数组
     */
    setExpandedRowKeys = expandedRowKeys => {
        this.setState({ expandedRowKeys: expandedRowKeys || [] });
    };

    /**
     * 获取当前展开的行键列表
     * @returns {array} 当前展开的行键数组
     */
    getExpandedRowKeys = () => {
        return this.state.expandedRowKeys;
    };
    setDetail(detail) {
        this.setState({ detail });
    }
    renderDeleteRow({ api, id, title }) {
        return (
            <div
                className="danger"
                onClick={() => {
                    Modal.confirm({
                        content: title,
                        onOk: () => {
                            lib.request({
                                url: api,
                                data: { id },
                                needMask: true,
                                success: () => {
                                    message.success("操作成功");
                                    this.load(true);
                                },
                            });
                        },
                    });
                }}>
                删除
            </div>
        );
    }
    renderTable() {
        console.log("expandedRowKeys", this.state.expandedRowKeys);
        const that = this;
        let { config, dataList, table, selectedIdList, pagination, _loading, sorter } = this.state;
        let maxWidth = 0;
        let list = config.tableFieldList
            .filter(item => item.fixed != "hide")
            .sort((a, b) => {
                var type = ["left", "show", "right"];
                return type.indexOf(a.fixed) - type.indexOf(b.fixed);
            });
        let columns = list.map(item => {
            let fixed = item.fixed;
            if (["left", "right"].indexOf(item.fixed) === -1) {
                fixed = undefined;
            }
            var column = {
                title: item.tooltip ? (
                    <Tooltip placement="topLeft" title={item.tooltip} arrowPointAtCenter>
                        {item.title} <QuestionCircleOutlined />
                    </Tooltip>
                ) : (
                    item.title
                ),
                dataIndex: item.key,
                width: item.width,
                ellipsis: { showTitle: true },
                fixed: fixed,
                sorter: item.sorter,
                sortOrder: sorter.field == item.key && sorter.order,
                showSorterTooltip: !item.tooltip,
                onHeaderCell: column => {
                    return {
                        width: column.width,
                        onResize: (e, { size }) => {
                            item.width = size.width;
                            this.setState({ config });
                        },
                    };
                },
            };
            maxWidth += column.width;
            if (item.type == "function" || item.type == "js") {
                column.render = (_, row, index) => {
                    try {
                        return item.type == "js" ? eval(item.key) : this[item.key](row, index);
                    } catch (e) {
                        console.error(new Error(`error expression ${item.key}`));
                    }
                };
            }
            return column;
        });

        let rowSelection = config.page.isBatch && {
            onChange: (selectedIdList, selectedRows) => {
                this.setState({ selectedIdList, selectedRows });
            },
            fixed: true,
            preserveSelectedRowKeys: true,
            selectedRowKeys: selectedIdList,
            getCheckboxProps: this.getCheckboxProps, //getCheckboxProps=(row)=>{return {disabled:true}} 选择禁用属性
        };
        //列表展开
        let expandable = !this.renderExpandRow
            ? null
            : {
                  rowExpandable: row => this.renderExpandRow(row, false) != null,
                  expandedRowRender: (row, _, __, expanded) => this.renderExpandRow(row, expanded),
                  expandedRowKeys: this.state.expandedRowKeys, // 受控的展开行
                  onExpand: this.handleExpand, // 展开/收起事件处理
              };
        return (
            <div className="search-list-table">
                <Table
                    rowSelection={rowSelection}
                    rowKey="id"
                    size="small"
                    bordered={config.page.bordered}
                    pagination={false}
                    expandable={expandable}
                    components={{ header: { cell: ResizableTitle } }}
                    dataSource={dataList}
                    columns={columns}
                    onChange={this.handleTableChange}
                    scroll={{ x: maxWidth, y: table.height }}></Table>
            </div>
        );
    }
    handleTableChange = (pagination, filters, sorter) => {
        let data = {};
        if (sorter.order) {
            data = {
                order: sorter.order,
                field: sorter.field,
            };
        }
        this.setState(
            prevState => ({
                sorter: data,
                pagination: {
                    ...prevState.pagination,
                    currentPage: 1,
                },
            }),
            () => this.load(),
        );
    };
    renderPagination() {
        return (
            <Pagination
                showQuickJumper
                showSizeChanger
                pageSize={this.state.pagination.pageSize}
                pageSizeOptions={["10", "20", "30", "40", "50", "100", "200"]}
                current={this.state.pagination.currentPage}
                total={this.state.pagination.totalCount}
                onChange={(page, pageSize) => {
                    this.setState(
                        prevState => {
                            const newPagination = { ...prevState.pagination };
                            newPagination.currentPage = page;
                            if (newPagination.pageSize != pageSize) {
                                newPagination.pageSize = pageSize;
                                newPagination.currentPage = 1;
                            }
                            return { pagination: newPagination };
                        },
                        () => {
                            this.load(true, true);
                            this.paginationChange && this.paginationChange(page, pageSize);
                        },
                    );
                }}
                showTotal={total => `总共 ${total} 条`}
            />
        );
    }
    setTableConfigureStorage(tableFieldList) {
        let { config } = this.state;
        config.tableFieldList = tableFieldList;
        this.saveTableFieldListConfig(config);
        this.setState({ config });
    }
    renderOperation() {
        let { config, selectedRows } = this.state;
        const that = this;
        let page = config.page;
        return (
            <>
                <div className="operation-left-panel">
                    <Space>
                        {config.isBatch && !!selectedRows.length && `共选择 ${selectedRows.length} 条数据`}
                        {this.renderLeftOperation && this.renderLeftOperation()}
                    </Space>
                </div>
                <div>
                    <Space className="operation-left-panel-space">
                        {this.renderRightOperation && this.renderRightOperation()}
                        {page?.import && this.importAuth() && (
                            <Button
                                className="btn import"
                                disabled={page.importDisabled || false}
                                onClick={() => {
                                    let disableImport = false,
                                        importExtendParam = "";
                                    if (this.beforeImport) {
                                        let beforeImport = this.beforeImport();
                                        disableImport = beforeImport.disableImport;
                                        importExtendParam = beforeImport.importExtendParam;
                                    }
                                    if (!disableImport) {
                                        let importExtendParamBase64 = window.btoa(importExtendParam);
                                        let url = `/excel/import-data?page_title=${lib.getParam(
                                            "page_title",
                                        )}导入&code=${encodeURIComponent(
                                            page.import,
                                        )}&importExtendParam=${importExtendParamBase64}`;
                                        if (lib.getParam("compatible") == "true") {
                                            url = `/excel/import-excel?page_title=${lib.getParam(
                                                "page_title",
                                            )}导入&api=${encodeURIComponent(page.import)}`;
                                        }
                                        lib.openPage(url, () => {
                                            this.load();
                                        });
                                    }
                                }}>
                                导入 &#xe639;
                            </Button>
                        )}
                        {this._renderExport(page)}
                        <SortTable
                            list={config.tableFieldList}
                            onSortEnd={tableFieldList => that.setTableConfigureStorage(tableFieldList)}
                        />
                    </Space>
                </div>
            </>
        );
    }

    _renderExport(page) {
        const customerExtraParam = this.customerExportExtraParam();
        return (
            page?.export &&
            this.exportAuth() && (
                <ExportBtn
                    exportDisabled={page.exportDisabled}
                    exportVerify={page.exportVerify}
                    exportUrl={page.export}
                    exportUrlParam={{ ...this.state.pagination, ...this.state.search, ...customerExtraParam }}
                />
            )
        );
    }
    customerExportExtraParam() {
        return {};
    }
    importAuth() {
        let importAuth = this.state.buttonAuth?.importAuth;
        if (importAuth === undefined) {
            importAuth = true;
        }
        return importAuth;
    }
    exportAuth() {
        let exportAuth = this.state.buttonAuth?.exportAuth;
        if (exportAuth === undefined) {
            exportAuth = true;
        }
        return exportAuth;
    }
    saveTableFieldListConfig(config) {
        localStorage[config.id] = JSON.stringify({
            tableFieldList: config.tableFieldList,
            tableFieldListVersion: config.tableFieldListVersion,
        });
    }
    /**
     * 修改defaultSearch，可传入对象，如果跟筛选表单key值相同，会填写在表单上，如果要清空某项，请传入空字符串
     * @param params object
     * @deprecated since v7.3.0-beta.66 请使用setDefaultSearchCondition
     */
    changeImmutable = params => {
        let { defaultSearch } = this.state;
        Object.entries(params).map(([key, value]) => {
            defaultSearch = defaultSearch.set(key, value);
        });
        this.setState({ defaultSearch });
    };

    /**
     * 默认重置清空控制
     * @return {{defaultSearchParamClearable: boolean, urlSearchParamClearable: boolean}}
     */
    initResetClearConfig() {
        return {
            defaultSearchParamClearable: true,
            urlSearchParamClearable: false,
        };
    }
    /**
     * 设置默认搜索条件
     * @return {*}
     */
    setDefaultSearchCondition = defaultSearchParam => {
        this.searchRef.current?.setDefaultSearchCondition(defaultSearchParam);
    };
    /**
     * 设置表单搜索条件
     * @return {*}
     */
    setSearchCondition = searchParam => {
        this.searchRef.current?.setSearchCondition(searchParam);
    };
    /**
     * 设置搜索条件清空
     * @param key
     * @param value
     * @return {*|void}
     */
    setResetClearConfig = (key, value) => {
        this.searchRef.current?.setResetClearConfig(key, value);
    };
    getSearchCondition = () => {
        this.searchRef.current?.getSearchCondition();
    };
    searchCheck(search, searchSource) {
        const msgs = [];
        this.state.config.searchKeyList.map(item => {
            if (item.required && !search[item.key]) {
                msgs.push(
                    `${item.label}是${
                        ["select", "select-textarea", "select-check"].includes(item.type) ? "必选的" : "必填的"
                    }`,
                );
            }
        });
        if (msgs.length === 0) {
            this.load(true);
            this.onSearch && this.onSearch(search);
        } else {
            if (searchSource === SearchSourceType.DEFAULT_SEARCH) {
                this.setState({
                    _loading: false,
                });
            } else {
                msgs.forEach(item => {
                    message.error(item);
                });
                this.resetPage();
            }
        }
    }
    resetPage() {
        this.setState({
            pagination: {
                currentPage: 1,
                pageSize: 20,
                totalPage: 1,
            },
            dataList: [],
            _loading: false,
        });
    }
    render() {
        let { config, detail, _loading, table, defaultSearch } = this.state;
        if (!config) {
            return <Skeleton active />;
        }

        return (
            <ConfigProvider locale={zhCN}>
                <div className={`config-center-v3 ${this.props.name}`}>
                    <div className="search-top-panel">{this.renderSearchTopView && this.renderSearchTopView()}</div>
                    {this.renderModal && this.renderModal()}
                    <MyDraggable
                        axis="y"
                        size={document.body.offsetHeight - 300}
                        onStop={() => event.emit("window.resize")}>
                        <div className="search-list">
                            <div>
                                <div className="search-condition-panel">
                                    <SearchConditionList
                                        ref={this.searchRef}
                                        defaultSearch={defaultSearch}
                                        initResetClearConfig={this.initResetClearConfig()}
                                        searchKeyList={config.searchKeyList}
                                        defaultCollapsed={config.page && config.page.defaultCollapsed}
                                        onSearch={(search, searchSource) => {
                                            this.setState(
                                                prevState => {
                                                    const newState = {
                                                        search: search,
                                                        pagination: {
                                                            ...prevState.pagination,
                                                            currentPage: 1,
                                                        },
                                                        selectedIdList: [],
                                                        selectedRows: [],
                                                    };

                                                    if (searchSource === SearchSourceType.RESET_BUTTON) {
                                                        newState.sorter = {};
                                                        event.emit("onSearchReset");
                                                    }

                                                    return newState;
                                                },
                                                () => {
                                                    this.searchCheck(search, searchSource);
                                                },
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="operation-top-panel">
                                {this.renderOperationTopView && this.renderOperationTopView()}
                            </div>
                            <div className="operation-panel">{this.renderOperation()}</div>
                            <div className="table-top-panel">
                                {this.renderTableTopView && this.renderTableTopView()}
                            </div>
                            <div className="table-panel" ref={table.panel}>
                                <Spin spinning={_loading} tip="正在处理中，请稍等">
                                    {this.renderTable()}
                                </Spin>
                            </div>
                            <div>
                                {this.state.pagination?.totalCount > 0 && (
                                    <div className="pagination-panel">{this.renderPagination()}</div>
                                )}
                            </div>
                        </div>
                        {detail && (
                            <div className="config-center-detail">
                                <div
                                    className="close"
                                    onClick={() => {
                                        this.setState({ detail: null });
                                    }}>
                                    &#xe60c;
                                </div>
                                <div className="detail-content">
                                    {detail && this.renderDetail && this.renderDetail(detail)}
                                </div>
                            </div>
                        )}
                    </MyDraggable>
                </div>
            </ConfigProvider>
        );
    }
}
